import { render, staticRenderFns } from "./ArtistItemList.vue?vue&type=template&id=4f88b148"
import script from "./ArtistItemList.vue?vue&type=script&lang=ts"
export * from "./ArtistItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports